// extracted by mini-css-extract-plugin
export default {"nav":"ProductsPagination_nav__n306c","pagNumber":"ProductsPagination_pagNumber__jbjH3","currPage":"ProductsPagination_currPage__dUjnf"};